module.exports = __webpack_public_path__ + "static/Film_Editing_p2b-67e505904b22f302a9efeee98cec5bae.mp4";